import React from "react";
import { Outlet, Route, Routes } from "react-router-dom";
import AppLayout from "../layouts/AppLayout";
import Index from "../pages/Index";
import Park from "../pages/Park";
import Checkout from "../pages/Checkout";
import CheckoutPayment from "../pages/CheckoutPayment";
import PaymentConfirmation from "../pages/PaymentConfirmation";
import MyProfile from "../pages/MyProfile";
import MyBookings from "../pages/MyBookings";
import MyFriendsAndFamily from "../pages/MyFriendsAndFamily";
import TicketView from "../pages/TicketView";
import ParkDetails from "../pages/ParkDetails";
import SearchResults from "../pages/SearchResult";
import PrintTicket from "../pages/PrintTicket";

export default function Router() {
  return (
    <Routes>
      <Route
        element={
          <AppLayout>
            <Outlet />
          </AppLayout>
        }
      >
        <Route path="/" element={<Index />} />
        <Route path="/park/:id" element={<Park />} />
        <Route path="/search-results" element={<SearchResults />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/checkout-payment" element={<CheckoutPayment />} />
        <Route path="/my-profile" element={<MyProfile />} />
        <Route path="/my-bookings" element={<MyBookings />} />
        <Route path="/my-friends-and-family" element={<MyFriendsAndFamily />} />
        <Route path="/ticket-view/:bookingId" element={<TicketView />} />
        <Route path="/park-details/:id" element={<ParkDetails />} />
        <Route path="/success" element={<PaymentConfirmation />} />
      </Route>
      <Route path="/print/:bookingId" element={<PrintTicket />} />
    </Routes>
  );
}
